import { TablesDisplayGridRowData } from '@tableau/data-catalog-client-components';
import { TablesGraphQLResourceQuery } from '../../catalog/fetchers/TablesGraphQLResourceQuery';
import { Messages } from '../../codegen/Localize';
import { FeatureFlags } from '../FeatureFlags';
import { Module } from '../Module';
import { DeleteTablesRequest } from '../ServerApi/requests/DeleteTablesRequest';
import { GetTableActionsRequest } from '../ServerApi/requests/GetTableActionsRequest';
import { ITableCertificationParams, SetTableCertificationRequest } from '../ServerApi/requests/SetTableCertificationRequest';
import { ITableDescriptionParams, SetTableDescriptionRequest } from '../ServerApi/requests/SetTableDescriptionRequest';
import { ITableContactParams, SetTablesContactRequest } from '../ServerApi/requests/SetTablesContactRequest';
import { IResult } from '../ServerApi/types/IResponse';
import { TableAllowedActions } from '../ServerApi/types/TableAllowedActions';
import { ErrorNotifyingServer } from '../services/ErrorNotifyingServer';
import { ServerService } from '../services/ServerService';
import { ToasterService, ToastType } from '../services/ToasterService';
import { IActionResource, IListResource } from './Resource';

export class Tables implements IActionResource<TableAllowedActions>, IListResource<TablesDisplayGridRowData> {

  public static $inject = [
    '$q',
    'ErrorNotifyingServer',
    'ToasterService',
  ];

  private server: ServerService;
  private allQuery: TablesGraphQLResourceQuery;

  constructor(
    private $q: ng.IQService,
    private ErrorNotifyingServer: ErrorNotifyingServer,
    private toaster: ToasterService,
  ) {
    this.server = ErrorNotifyingServer.getServerService();
    this.allQuery = new TablesGraphQLResourceQuery();
  }

  public all(): TablesGraphQLResourceQuery {
    return this.allQuery;
  }

  public actions(id: string): ng.IPromise<TableAllowedActions> {
    if (FeatureFlags.dataCatalogPermissionEnabled) {
      return this.server.sendRequest(new GetTableActionsRequest(id));
    } else {
      return this.$q.resolve({
        setDescription: false,
        setPermissions: false,
        updateRemoveDataQuality: false,
        sendEmail: false,
      });
    }
  }

  public deleteTable = async (id: string, name: string): Promise<IResult> => {
    return this.ErrorNotifyingServer
      .sendRequestAndDelay(new DeleteTablesRequest({ids: [id]}))
      .then(r => this.toast(r, Messages.removeExternalContentSuccessful({ ITEM_NAME: name }), Messages.removeFailed()));
  }

  public setTableDescription = async (args: ITableDescriptionParams): Promise<IResult> => {
    return this.ErrorNotifyingServer
      .sendRequestAndDelay(new SetTableDescriptionRequest(args))
      .then(r => this.toast(r, Messages.editDescriptionSuccessfulWithWait(), Messages.editDescriptionFailure()));
  }

  public setTableCertification = async (args: ITableCertificationParams): Promise<IResult> => {
    return this.ErrorNotifyingServer
      .sendRequestAndDelay(new SetTableCertificationRequest(args))
      .then(r => {
        return this.toast(r, Messages.editCertificationSuccessful(), Messages.editCertificationFailure());
      });
  }

  public setContact = async (args: ITableContactParams): Promise<IResult> => {
    return this.ErrorNotifyingServer
    .sendRequestAndDelay(new SetTablesContactRequest(args));
  }

  private toast(result: IResult, successMessage: string, failureMessage: string): any {
    if (result.errors && result.errors.length > 0) {
      this.toaster.pop({
        type: ToastType.Error,
        text: failureMessage
      });
    } else {
      this.toaster.pop({
        type: ToastType.Info,
        text: successMessage
      });
    }
  }
}

Module.instance().service('Tables', Tables);
